import { HttpClient, HttpClientModule } from '@angular/common/http';
import { APP_INITIALIZER, ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AutenticacaoModule } from './autenticacao/autenticacao.module';
import { InterceptadorModule } from './interceptadores/interceptador.module';
import { ConfirmModule } from './libs/confirm/confirm.module';
import { LoadingModule } from './libs/loading/loading.module';
import { ToastModule } from './libs/toast/toast.module';
import { LoadingBarHttpClientModule } from '@ngx-loading-bar/http-client';
import { RelatorioModule } from './relatorio/relatorio.module';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { AcompanhamentoMeusModule } from './acompanhamento-meus/acompanhamento-meus.module';
import { AtendimentoMeusModule } from './atendimento-meus/atendimento-meus.module';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { ImagemVisualizadorModule } from './libs/imagem-visualizador/imagem-visualizador.module';
import * as Sentry from "@sentry/angular";
import { Router } from "@angular/router";
import { CoreModule } from './core/core.module';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from 'src/environments/environment';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
      // Register the ServiceWorker as soon as the app is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000'
    }),

    CoreModule,
    AutenticacaoModule.forRoot(),
    HttpClientModule,
    TranslateModule.forRoot({
      defaultLanguage: 'pt',
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    RelatorioModule,
    ImagemVisualizadorModule,
    InterceptadorModule,
    AppRoutingModule,
    LoadingModule,
    LoadingBarHttpClientModule,
    ConfirmModule,
    ToastModule,
    AcompanhamentoMeusModule,
    AtendimentoMeusModule
  ],
  providers: [{
    provide: ErrorHandler,
    useValue: Sentry.createErrorHandler({
      showDialog: false,
    }),
  }, {
    provide: Sentry.TraceService,
    deps: [Router],
  },
  {
    provide: APP_INITIALIZER,
    useFactory: () => () => { },
    deps: [Sentry.TraceService],
    multi: true,
  },
  ],
  bootstrap: [AppComponent],
  exports: [
  ]
})
export class AppModule { }
